/* start - flights_split_bounds_us */
import { ActionsUnion, createAction } from "@bookingcom/flights-core";
import { UISearchResults, UIClientFetchError } from "@flights/types";

export enum ActionTypes {
  fetchOutbound = "searchResultsBounds/fetchOutbound",
  fetchInbound = "searchResultsBounds/fetchInbound",
  fetchSuccessOutbound = "searchResultsBounds/fetchSuccessOutbound",
  fetchSuccessInbound = "searchResultsBounds/fetchSuccessInbound",
  fetchErrorOutbound = "searchResultsBounds/fetchErrorOutbound",
  fetchErrorInbound = "searchResultsBounds/fetchErrorInbound",
  resetOutbound = "searchResultsBounds/resetOutbound",
  resetInbound = "searchResultsBounds/resetInbound",
  resetAllBounds = "searchResultsBounds/resetAllBounds"
}

export const actions = {
  fetchOutbound: createAction(() => ({
    type: ActionTypes.fetchOutbound,
    payload: {}
  })),
  fetchInbound: createAction(() => ({
    type: ActionTypes.fetchInbound,
    payload: {}
  })),
  fetchSuccessOutbound: createAction((data: UISearchResults) => ({
    type: ActionTypes.fetchSuccessOutbound,
    payload: data
  })),
  fetchSuccessInbound: createAction((data: UISearchResults) => ({
    type: ActionTypes.fetchSuccessInbound,
    payload: data
  })),
  fetchErrorOutbound: createAction((error: UIClientFetchError) => ({
    type: ActionTypes.fetchErrorOutbound,
    payload: error
  })),
  fetchErrorInbound: createAction((error: UIClientFetchError) => ({
    type: ActionTypes.fetchErrorInbound,
    payload: error
  })),
  resetOutbound: createAction(() => ({
    type: ActionTypes.resetOutbound,
    payload: {}
  })),
  resetInbound: createAction(() => ({
    type: ActionTypes.resetInbound,
    payload: {}
  })),
  resetAllBounds: createAction(() => ({
    type: ActionTypes.resetAllBounds,
    payload: {}
  }))
};

export type Actions = ActionsUnion<typeof actions>;
/* end - flights_split_bounds_us */
